import { render } from "./task.vue?vue&type=template&id=93310b80&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"

import "./task.vue?vue&type=style&index=0&id=93310b80&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93310b80"]])

export default __exports__